import React, { createContext, useRef, useState } from "react";


const defaultState = {};

const AppContext = createContext(defaultState);

const AppProvider = ({ children }) => {
	const headerRef = useRef(null);
	const stickyIsiRef = useRef(null);
	const isiRef = useRef(null);
	const [isHeaderVisible, setIsHeaderVisible] = useState(true);
	const [showExitModal, setShowExitModal] = useState(false);
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [videoId, setVideoId] = useState("");
  const [videoTitle, setVideoTitle] = useState("");
	const [videoThumbnail, setVideoThumbnail] = useState("");
	const [exitUrl, setExitUrl] = useState("");

  const setHeaderVisible = (visible) => {
    setIsHeaderVisible(visible);
  };

  const openVideoModal = (videoId, videoTitle, videoThumbnail) => {
    setShowVideoModal(true);
    setVideoId(videoId);
    setVideoTitle(videoTitle);
		setVideoThumbnail(videoThumbnail);
  };

  const closeVideoModal = () => {
    setShowVideoModal(false);
    setVideoId("");
    setVideoTitle("");
		setVideoThumbnail("");
  };

	// Exit modal functions
	const openExitModal = (url) => {
		setExitUrl(url);
		setShowExitModal(true);
	};

	const closeExitModal = () => {
		setShowExitModal(false);
	};

	const store = {
		headerRef,
		stickyIsiRef,
		isiRef,
		isHeaderVisible,
		setHeaderVisible,
		showExitModal,
		exitUrl,
		openExitModal,
		closeExitModal,
    showVideoModal,
    openVideoModal,
    closeVideoModal,
    videoId,
    videoTitle,
		videoThumbnail,
	};

	return <AppContext.Provider value={store}>{children}</AppContext.Provider>;
};

export { AppProvider };
export default AppContext;

